import { QuestionType } from '@/models/configurator/question';
export class Answer {
  id?: number;
  question?: number;
  choice?: number;
  value?: number;
  configuration?: number;

  constructor(question: number, configuration: number) {
    this.question = question;
    this.configuration = configuration;
  }

  /**
   * Update Value for answer based on question type and returns answer
   * @param {*} value
   * @param {number} type
   * @returns {void}
   */
  public updateAnswer(value: any, type?: QuestionType): void {
    switch (type) {
      case QuestionType.Value:
        this.value = value;
        break;
      case QuestionType.MultipleChoice:
      case QuestionType.NumericChoice:
        this.choice = value;
        break;
      default:
        break;
    }
  }
}
